// extracted by mini-css-extract-plugin
module.exports = {"TertiaryItems":"TertiaryItems_TertiaryItems__eCxm4","container":"TertiaryItems_container__ldjSg","item":"TertiaryItems_item__qBmXF"};